import React from "react";

const HomeVideo = () => {
return (
    <div className="mt-20">
      <h1 className="text-sm md:text-3xl text-[#D8AE96] uppercase text-center mb-10">
        Having a great style is to feel good in what you wear...
      </h1>
      <div className="flex justify-center">
        <iframe
          width="566"
          height="256"
          src="https://www.youtube.com/embed/Xg_CLNeoxAQ"
          title="Piti x Asteria"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          className="rounded-lg shadow-lg"
        ></iframe>
      </div>
    </div>
  );
};

export default HomeVideo;
